var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.btnTooltip),expression:"btnTooltip"}],class:_vm.btnClass,attrs:{"id":"scarica-tutte"},on:{"click":_vm.handleClick}},[_c('font-awesome-icon',{attrs:{"icon":_vm.btnIco,"spin":_vm.requesting}}),_vm._v(" Scarica ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }